import OS from 'framework/utils/OS';

export function resizePopup(popupBody: HTMLElement, ...buttons: HTMLElement[]): void {
  if (OS.desktop) {
    const scale = Math.min(
      1,
      window.innerWidth / (popupBody.clientWidth * 1.1),
      window.innerHeight / (popupBody.clientHeight * 1.1),
    );
    popupBody.style.transform = `translate(-50%, -50%) scale(${scale})`;

    buttons.forEach((button) => {
      if (button) button.style.transform = `scale(${1.1 / scale})`;
    });
  } else {
    popupBody.style.width = '100%';
    popupBody.style.transform = 'translate(-50%, 0)';
    popupBody.style.top = '0%';
  }
}
